import { QueryClient } from '@tanstack/react-query'

import { isApiError } from './api-error'

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Live fleet data is refreshed by its own hooks (and, from phase 1, by the
        // websocket); the generic default only has to avoid hammering the API.
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // A 4xx will not become a 200 by asking again. That includes the 404 the
          // API returns for another tenant's resource — retrying it would turn a
          // deliberate non-answer into a burst of probing traffic.
          if (isApiError(error) && error.status >= 400 && error.status < 500) return false
          return failureCount < 2
        },
      },
      mutations: { retry: false },
    },
  })
}
